exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Inbox_inbox__aYUbN {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  min-width: 960px;\n  max-width: 1530px; }\n", ""]);

// exports
exports.locals = {
	"inbox": "Inbox_inbox__aYUbN"
};